import useRenderBlipChat from 'common/hooks/useRenderBlipChat';
import { isOriginHelpCenter } from 'common/user';
import { destroyWidget, getFormattedAccountData, setupAppKey } from 'pages/chat/methods';
import { forwardRef, ReactElement, useEffect, useImperativeHandle } from 'react';
import type { IChatMethods } from 'common/hooks/useChatMethods';
import { dispatchCustomEvent } from 'common/utils/dispatchCustomEvent';
import { EVENTS } from 'common/constants';
import CSSVariables from 'common/utils/CSSVariable';
import useAutoHideOnMobile from 'common/hooks/useAutoHideOnMobile';
import Origin from 'common/utils/Origin';

function BlipChat(props: any, ref: React.Ref<IChatMethods>): ReactElement {
  const { locale, userId, name, entityType } = props;
  const appKey = setupAppKey();
  const isHelpCenter = isOriginHelpCenter();

  const { renderBlipChatWidget, blipChat } = useRenderBlipChat({
    userId,
    userAccount: getFormattedAccountData({ id: userId, ...props }),
    name,
    entityType,
    locale,
    withButton: isHelpCenter ? { color: '#EF4E23', icon: '' } : undefined,
  });

  useImperativeHandle(ref, () => ({
    show: () => {
      const display = CSSVariables.get('--app-chat-display');
      if (display !== 'block') {
        CSSVariables.set('--app-chat-display', 'block');
        dispatchCustomEvent(EVENTS.ON_CHAT_SHOW);
      }
    },
    hide: () => {
      const display = CSSVariables.get('--app-chat-display');
      if (display !== 'none') {
        CSSVariables.set('--app-chat-display', 'none');
        dispatchCustomEvent(EVENTS.ON_CHAT_HIDE);
      }
    },
    open: () => {
      if (!blipChat.current.widget.isOpen) blipChat.current.toogleChat();
    },
    close: () => {
      if (blipChat.current.widget.isOpen) blipChat.current.toogleChat();
    },
    toggle: () => {
      blipChat.current.toogleChat();
    },
  }));

  useAutoHideOnMobile(ref, Origin.isBW);

  useEffect(() => {
    renderBlipChatWidget(appKey);
    if (!isHelpCenter) {
      import('./vulcano-style.scss');
    }
    return () => {
      window.zE?.('messenger', 'hide');
      destroyWidget(blipChat.current);
    };
  }, [appKey, renderBlipChatWidget]);
  return <></>;
}

export default forwardRef(BlipChat);
